export const CHANGE_NOTICE_KEY = 'account-resources-change-notice:v1';
export const CHANGE_NOTICE_CUTOFF_UTC_MS = Date.parse('2026-05-31T00:00:00Z');
export const ACCOUNT_CREATED_CUTOFF_UTC_MS = Date.parse('2026-05-18T00:00:00Z');
const HAS_EVER_AUTHENTICATED_KEY = 'has-ever-authenticated';

export const isBeforeCutoff = (nowMs = Date.now()) => {
  return Number.isFinite(nowMs) && nowMs < CHANGE_NOTICE_CUTOFF_UTC_MS;
};

export const isAccountCreatedBeforeCutoff = (accountCreatedAt) => {
  if (typeof accountCreatedAt !== 'string' || accountCreatedAt.trim() === '') {
    return false;
  }

  const createdAtMs = Date.parse(accountCreatedAt);
  if (!Number.isFinite(createdAtMs)) {
    return false;
  }

  return createdAtMs < ACCOUNT_CREATED_CUTOFF_UTC_MS;
};

export const shouldShowAccountChangeNotice = ({
  nowMs = Date.now(),
  accountCreatedAt = null,
} = {}) => {
  if (!isBeforeCutoff(nowMs)) {
    return false;
  }

  if (!isAccountCreatedBeforeCutoff(accountCreatedAt)) {
    return false;
  }

  try {
    if (typeof window === 'undefined' || !window.localStorage) {
      return false;
    }

    const hasEverAuthenticated = window.localStorage.getItem(HAS_EVER_AUTHENTICATED_KEY) === 'true';
    if (!hasEverAuthenticated) {
      return false;
    }

    return window.localStorage.getItem(CHANGE_NOTICE_KEY) !== 'true';
  } catch (_) {
    return false;
  }
};

export const markAccountChangeNoticeShown = () => {
  try {
    if (typeof window === 'undefined' || !window.localStorage) {
      return;
    }
    window.localStorage.setItem(CHANGE_NOTICE_KEY, 'true');
  } catch (_) {
    // Ignore storage failures to avoid breaking UI flows.
  }
};

export const shouldOpenAccountChangeNoticeModal = ({
  isAdminPortalBuild = false,
  authLoaded = false,
  isGlobalModalOpen = false,
  nowMs = Date.now(),
  accountCreatedAt = null,
} = {}) => {
  if (isAdminPortalBuild) {
    return false;
  }
  if (!authLoaded) {
    return false;
  }
  if (isGlobalModalOpen) {
    return false;
  }
  return shouldShowAccountChangeNotice({
    nowMs,
    accountCreatedAt,
  });
};
